import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#0F1629] flex items-center justify-center px-4 dark-section" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle size={36} className="text-red-400" aria-hidden="true" />
        </div>
        <h1 className="text-3xl font-heading font-black text-white mb-3">Payment Cancelled</h1>
        <p className="text-gray-400 mb-2">No charges were made. You can try again whenever you're ready.</p>
        <p className="text-xs text-gray-600 mb-8">If you experienced an issue with checkout, please contact support.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 px-6 py-3 bg-brand-green text-brand-navy font-bold rounded-xl hover:bg-brand-green/90 transition-colors"
            data-testid="retry-payment-btn"
          >
            <RefreshCw size={16} /> Try Again
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 border border-white/15 text-white font-medium rounded-xl hover:border-white/25 transition-colors"
          >
            <ArrowLeft size={16} /> Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
